/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReviewPalAuthSubmissionRequest
 */
export interface ReviewPalAuthSubmissionRequest {
    /**
     * Payor ID (required if is_non_submission_flow is false)
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    payor_id?: string;
    /**
     * Auth platform ID (required if is_non_submission_flow is false)
     * @type {string}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    auth_platform_id?: string;
    /**
     * Whether this is a non-submission flow
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    is_non_submission_flow?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof ReviewPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
}

/**
 * Check if a given object implements the ReviewPalAuthSubmissionRequest interface.
 */
export function instanceOfReviewPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReviewPalAuthSubmissionRequestFromJSON(json: any): ReviewPalAuthSubmissionRequest {
    return ReviewPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function ReviewPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReviewPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'payor_id': !exists(json, 'payor_id') ? undefined : json['payor_id'],
        'auth_platform_id': !exists(json, 'auth_platform_id') ? undefined : json['auth_platform_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
    };
}

export function ReviewPalAuthSubmissionRequestToJSON(value?: ReviewPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'payor_id': value.payor_id,
        'auth_platform_id': value.auth_platform_id,
        'is_non_submission_flow': value.is_non_submission_flow,
        'include_lead_summary_report': value.include_lead_summary_report,
    };
}

